import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  max-width: 100%;
  margin: 0 auto;

  .layout {
    width: 100%;
  }

  & > :first-child {
    margin-bottom: 8px !important;
  }

  @media (min-width: ${({ theme }) => theme.mediaQueries.sm}) {
    padding: 16px;
  }

  @media (max-width: ${({ theme }) => theme.mediaQueries.sm}) {
    padding: 0;

    .react-grid-item {
      width: 100% !important;
      position: relative !important;
      transform: none !important;
      margin: 0 !important;
      left: 0 !important;
    }
    .layout {
      display: flex;
      flex-direction: column;
      gap: 16px;
    }
  }
`;

export const LoadingWrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
